import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const FooterContainer = styled.div`
background-color: #F2F3F9;
padding: 4rem 0 2rem 0;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

@media screen and (max-width: 768px){
    padding: 3rem 0 1.5rem 0;
}

@media screen and (max-width: 480px){
    padding: 2rem 0 1rem 0;
}
`;

export const FooterLinksContainer = styled.div`
width: 100%;
max-width: 100px;
display: flex;
justify-content: center;

@media screen and (max-width: 820px) {
    padding-top: 32px;
}
`;

export const FooterLinksWrapper = styled.div`
display: flex;

@media screen and (max-width: 820px) {
    flex-direction: column;
}`;

export const FooterLinksItems = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
margin: 16px;
text-align: left;
width: 160px;
box-sizing: border-box;
color: #fff;

@media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
}
`;

export const FooterLinkTitle = styled.h2`
margin-bottom: 16px`;

export const FooterLink = styled(Link)`
color: #fff;
text-decoration: none;
margin-bottom: 0.5rem;

&:hover {
    color: #0467fb;
    transition: 0.3s ease-out;
}`;

export const SocialMedia = styled.section`
max-width: 1000px;
width: 100%;
`;

export const SocialMediaWrap = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
max-width: 1000px;
margin: 40px auto 0 auto;

@media screen and (max-width: 820px) {
    flex-direction: column;
}`;

export const WebsiteRights = styled.small`
color: black;
font-family: 'Poppins', sans-serif;
margin-bottom: 16px;
`;

export const SocialIcons = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 150px;
`;

export const SocialIconLink = styled.a`
color: black;
font-size: 24px;
`;

/**/

export const FooterRow = styled.div`
display: flex;
margin: 0 -15px -15px -15px;
flex-wrap: wrap;
align-items: center;
flex-direction: ${({imgStart}) => (imgStart ? 'row-reverse' : 'row')};
`;

export const FooterColumn = styled.div`
margin-bottom: 15px;
padding-right: 15px;
padding-left: 15px;
flex: 1;
max-width: 50%;
flex-basis: 50%;

@media screen and (max-width: 768px){
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
}
`;

export const TextWrapper = styled.div`
max-width: 540px;
padding-top:0;
padding-bottom: 60px;

@media screen and (max-width: 760px) {
    padding-bottom: 65px;
}
`;

export const Heading = styled.header`
margin-bottom: 24px;
font-size: 48px;
line-height: 1.1;
color: black;
font-family: 'Poppins', sans-serif;
font-weight: bold;

@media screen and (max-width: 960px){
    font-size: 36px;
}

@media screen and (max-width: 768px){
    font-size: 32px;
}

@media screen and (max-width: 480px){
    font-size: 28px;
    margin-bottom: 16px;
}
`;

export const Subtitle = styled.p`
max-width: 440px;
margin-bottom: 35px;
font-size: 18px;
line-height: 24px;
color : ${({lightTextDesc})=> (lightTextDesc? '#a9b3c1' : '#1c2237')};

@media screen and (max-width: 768px){
    max-width: 100%;
    font-size: 16px;
    line-height: 22px;
}

@media screen and (max-width: 480px){
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 25px;
}
`;

export const ImgWrapper = styled.div`
max-width: 555px;
display: flex;
justify-content: ${({start}) => (start ? 
    'flex-start' : 'flex-end')};
`;

export const Img = styled.img`
padding-right: 0;
border: 0;
max-width: 100%;
vertical-align: middle;
display: inline-block;
max-height: 700px;

@media screen and (max-width: 768px){
    max-height: 500px;
}

@media screen and (max-width: 480px){
    max-height: 350px;
}
`;



